var cookieStorage = require('./cookie');
var $ = require('jquery');

function setUpVoting(baseUrl, postId) {
  var voteId = cookieStorage.get('portfolio2013vote');

  if (voteId) {
    $('#inertia-vote-btn-' + voteId)
      .removeClass('inertia-vote-btn')
      .addClass('inertia-vote-highlight')
      .text('VOTED');
  }

  $('.inertia-vote-btn').bind('click', function(e) {
    e.preventDefault();
    if (voteId) {
      alert('One vote per day please! Try again tomorrow');
      return;
    }

    var el = $(this);
    var nonce = $('input#voting_nonce').val();
    var data = {
      'action': 'add_votes_options',
      'nonce': nonce,
      'voting_postid': el.attr('data-post-id'),
      'postid': postId
    };

    $.post(baseUrl + '/wp-admin/admin-ajax.php', data, function(response){
      if (response === 'invalid_nonce') {
        alert('There was a problem registering your vote. Please try again later.');
      } else {
        // Once per day
        cookieStorage.set('portfolio2013vote', el.attr('data-post-id'), +new Date() + 86400000);
        window.location = 'http://www.theinertia.com/voted/portfolio-challenge-2014-thank-you/';
      }
    });
  });
}

module.exports = {
  setUpVoting: setUpVoting
};
